import { Epg, EpgNumeration, LiveChannels } from 'common/constants/data-types';
import { pad } from 'common/services/helpers';
import * as langs from 'langs';
import { isEmpty, isNil, orderBy } from 'lodash';

export function convertToLanguage(resourceList?: { name: string }[]) {
  try {
    return !isEmpty(resourceList) && resourceList
      ? resourceList.map((e) => {
          const language = langs.where('2B', e.name);
          return language ? language.local : e.name;
        })
      : undefined;
  } catch (error) {
    console.warn(error);
    return undefined;
  }
}

export function findLanguageName(resourceList?: langs.Language['local'][], index?: number) {
  try {
    return !isNil(index) && !isEmpty(resourceList) && resourceList
      ? resourceList[index]
      : undefined;
  } catch (error) {
    console.warn(error);
    return undefined;
  }
}

// Compare function for validating identical episodes
export const compareEpisodes = (a: Epg, b: Epg) =>
  a.numeration.SeasonNumber === b.numeration.SeasonNumber &&
  a.numeration.EpisodeNumber === b.numeration.EpisodeNumber;

// Reduce the epg list to remove and sort repeating episodes
export const reduceEpisodes = (epgs: Epg[], liveChannels: LiveChannels): Epg[] => {
  const seen = new Set<string>();
  const result: Epg[] = [];

  for (const epg of epgs) {
    const key = `${epg.numeration.SeasonNumber}-${epg.numeration.EpisodeNumber}`;
    if (!seen.has(key)) {
      const episodes = epgs.filter(
        (e) =>
          e.numeration.SeasonNumber === epg.numeration.SeasonNumber &&
          e.numeration.EpisodeNumber === epg.numeration.EpisodeNumber
      );
      const prioritized = orderBy(
        episodes,
        [
          'stop',
          (e) => liveChannels[e.chan_id]?.position ?? 0,
          (e) => liveChannels[e.chan_id]?.resolution ?? 0
        ],
        ['asc', 'asc', 'desc']
      );
      result.push(prioritized[0]);
      seen.add(key);
    }
  }

  return result;
};

export const getEpisodeInfoText = (numeration?: EpgNumeration) => {
  if (!numeration) return null;

  const { EpisodeNumber, SeasonNumber } = numeration;
  let episodeInfo = '';
  if (SeasonNumber !== 0) episodeInfo += `С${pad(SeasonNumber.toString())} `;
  if (EpisodeNumber !== 0) episodeInfo += `Е${pad(EpisodeNumber.toString())}`;

  return isEmpty(episodeInfo) ? null : episodeInfo;
};
